import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerComponent } from 'src/app/components/banner/banner.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CreditLineComponent } from 'src/app/components/credit-line/credit-line.component';
import { AccountListComponent } from 'src/app/components/account-list/account-list.component';
import { VirtualOfficeTitleComponent } from 'src/app/components/virtual-office-title/virtual-office-title.component';
import { NumberPickerComponent } from 'src/app/components/shared/number-picker/number-picker.component';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { MatPaginatorModule, MatCardModule, MatListModule, MatSelectModule, MatSliderModule, MatDatepickerModule, MatPaginatorIntl } from '@angular/material';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatStepperModule } from '@angular/material/stepper';
import { MatBadgeModule } from '@angular/material/badge';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRippleModule } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';


import { LeadingZeroPipe } from 'src/app/pipes/leading-zero.pipe';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { RouterModule } from '@angular/router';
import { Ng5SliderModule } from 'ng5-slider';
import { FromToPipe } from 'src/app/pipes/from-to.pipe';
import { OnlyIntegerDirective } from 'src/app/directives/only-integer.directive';
import { PasswordChangeComponent } from 'src/app/components/user-management/password-change/password-change.component';
import { ImageContainerComponent } from 'src/app/components/image-container/image-container.component';
import { CommercialPurposeClauseComponent } from 'src/app/components/commercial-purpose-clause/commercial-purpose-clause.component';
import { PolicyConditionsTermsComponent } from 'src/app/components/policy-conditions-terms/policy-conditions-terms.component';
import { PolicyPrivacyWebComponent } from 'src/app/components/policy-privacy-web/policy-privacy-web.component';
import { ServiceRequestMapComponent } from 'src/app/components/service-request-map/service-request.component-map';
import { ServiceRequestComponent } from 'src/app/components/service-request/service-request.component';
import { ClientSectionComponent } from 'src/app/components/client-section/client-section.component';
import { ClientAddressSectionComponent } from 'src/app/components/client-address-section/client-address-section.component';
import { ComplaintComponent } from 'src/app/components/complaint/complaint.component';
import { ComplaintTopicComponent } from 'src/app/components/complaint-topic/complaint-topic.component';
import { NotificationAddressSectionComponent } from 'src/app/components/notification-address-section/notification-address-section.component';
import { ClientRepresentativeSectionComponent } from 'src/app/components/client-representative-section/client-representative-section.component';
import { ComplaintResponseComponent } from 'src/app/components/complaint-response/complaint-response.component';
import { BillNumberDirective } from 'src/app/directives/bill-number.directive';
import { PopupHomeComponent } from 'src/app/components/modals/popup-home/popup-home.component';
import { NguCarouselModule } from "@ngu/carousel";
import { PopoverModule } from "ngx-popover";
import { PopupReceiptComponent } from 'src/app/components/modals/popup-receipt/popup-receipt.component';
import { PopupServiceComponent } from 'src/app/components/modals/popup-service/popup-service.component';
import { PopupCartComponent } from 'src/app/components/modals/popup-cart/popup-cart.component';
import { PopupServiceListComponent } from 'src/app/components/modals/popup-service-list/popup-service-list.component';
import { ModalHelpComponent } from 'src/app/components/modal-help/modal-help.component';
import { PopupComplaintComponent } from 'src/app/components/modals/popup-complaint/popup-complaint.component';
import { PopupFnbComponent } from 'src/app/components/modals/popup-fnb/popup-fnb.component';
import { CreditLineFnbComponent } from 'src/app/components/credit-line-fnb/credit-line-fnb.component';
import { ExtraEventComponent } from 'src/app/components/extra-event/extra-event.component';
import { MatpaginatorLangService } from 'src/app/services/matpaginator-lang.service';
import { ModalLikeSweetComponent } from 'src/app/components/modal-like-sweet/modal-like-sweet.component';
import { AgmCoreModule } from '@agm/core';
import { EnvironmentServiceFactory } from 'src/app/core/providers/environment.provider';
import { Complaint2Component } from 'src/app/components/complaint-2/complaint-2.component';
import { Complaint2ExternalComponent } from 'src/app/components/complaint-2-external/complaint-2.component';
import { StatusTablePipe } from 'src/app/pipes/status-table.pipe';

 const apiKeyGoogleMap=EnvironmentServiceFactory().apiKeyGoogleMap;
  

@NgModule({
  declarations: [
    BannerComponent,
    CreditLineComponent,
    AccountListComponent,
    VirtualOfficeTitleComponent,
    LeadingZeroPipe,
    StatusTablePipe,
    FromToPipe,
    OnlyIntegerDirective,
    NumberPickerComponent,
    PasswordChangeComponent,
    ImageContainerComponent,
    CommercialPurposeClauseComponent,
    PolicyConditionsTermsComponent,
    PolicyPrivacyWebComponent,
    ServiceRequestComponent,
    ServiceRequestMapComponent,
    ClientSectionComponent,
    ClientAddressSectionComponent,
    ComplaintComponent,
    Complaint2Component,
    Complaint2ExternalComponent,
    ComplaintTopicComponent,
    ComplaintResponseComponent,
    NotificationAddressSectionComponent,
    ClientRepresentativeSectionComponent,
    BillNumberDirective,
    PopupHomeComponent,
    PopupReceiptComponent,
    PopupServiceComponent,
    PopupCartComponent,
    PopupServiceListComponent,
    ModalHelpComponent,
    PopupComplaintComponent,
    PopupFnbComponent,
    CreditLineFnbComponent,
    ExtraEventComponent,
    ModalLikeSweetComponent
  ],
  imports: [
    
    RouterModule,
    CommonModule,
    SlickCarouselModule,
    NgbModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatCheckboxModule,
    MatTabsModule,
    MatCardModule,
    MatSlideToggleModule,
    MatListModule,
    MatToolbarModule,
    MatExpansionModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatStepperModule,
    MatBadgeModule,
    MatSliderModule,
    MaterialFileInputModule,
    ReactiveFormsModule,
    FormsModule,
    MatMenuModule,
    Ng5SliderModule,
    NguCarouselModule,
    PopoverModule,
    MatRippleModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    MatRadioModule,
    AgmCoreModule.forRoot({
      apiKey:  apiKeyGoogleMap,
      libraries: ['places']
    })
  ],
  exports: [
    ServiceRequestComponent,
    ServiceRequestMapComponent,
    ClientSectionComponent,
    ClientAddressSectionComponent,
    BannerComponent,
    SlickCarouselModule,
    CreditLineComponent,
    AccountListComponent,
    VirtualOfficeTitleComponent,
    NgbModule,
    RouterModule,
    CommonModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatCheckboxModule,
    MatTabsModule,
    MatCardModule,
    MatSlideToggleModule,
    MatListModule,
    MatToolbarModule,
    MatExpansionModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatStepperModule,
    MatBadgeModule,
    MatSliderModule,
    MatRippleModule,
    MaterialFileInputModule,
    ReactiveFormsModule,
    FormsModule,
    MatMenuModule,
    LeadingZeroPipe,
    StatusTablePipe,
    Ng5SliderModule,
    FromToPipe,
    OnlyIntegerDirective,
    BillNumberDirective,
    NumberPickerComponent,
    PasswordChangeComponent,
    ImageContainerComponent,
    CommercialPurposeClauseComponent,
    PolicyConditionsTermsComponent,
    PolicyPrivacyWebComponent,
    ComplaintComponent,
    Complaint2Component,
    Complaint2ExternalComponent,
    ComplaintTopicComponent,
    ComplaintResponseComponent,
    NotificationAddressSectionComponent,
    ClientRepresentativeSectionComponent,
    PopupHomeComponent,
    NguCarouselModule,
    PopupReceiptComponent,
    PopupServiceComponent,
    PopupCartComponent,
    PopupServiceListComponent,
    ModalHelpComponent,
    PopupComplaintComponent,
    ClientRepresentativeSectionComponent,
    RecaptchaModule,
    RecaptchaFormsModule,
    MatRadioModule,
    PopupFnbComponent,
    CreditLineFnbComponent,
    ExtraEventComponent,
    ModalLikeSweetComponent
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: MatpaginatorLangService }
  ],
  entryComponents: [
    ModalLikeSweetComponent
  ]
})
export class SharedModule { }
